import axios from 'axios'


export default {
    actions: {
        axiosDeleteDepartment(ctx, data) {
            return axios.delete(process.env.VUE_APP_URL+"/department/" + data, {
                headers: {
                    'Authorization': 'token ' + ctx.getters.getToken,
                }
            }).then(response => {
                ctx.commit("responseDelete", response);
            }).catch(() => {
                // console.log(error);
            });
        },
        axiosChangeNameDepartment(ctx, data) {
          return axios.put(process.env.VUE_APP_URL+"/department/" + data.id, {
              name: data.name,
          }, {
              headers: {
                  'Authorization': 'token ' + ctx.getters.getToken,
              }
          }).catch(error=> {
              if(ctx.getters.getToken>20)
                  ctx.commit("setAlert", {show: true, text: error}, {root: true});
          })
        },
        axiosEditPermissionInDepartments(ctx, data) {
            // console.log(data);
            return axios.patch(process.env.VUE_APP_URL+"/set/permission/department/" + data.IDPer, {
                "type": data.type,
                "department": data.department,
                "related_staff": data.related_staff,
                such_columns: data.such_columns,
                "related_department": data.related_department,
                related_account: data.related_account,
            }, {
                headers: {
                    'Authorization': 'token ' + ctx.getters.getToken,
                    "accept": "application/json",
                    "Content-Type": "application/json",
                }
            }).catch(error=> {
                if(ctx.getters.getToken>20)
                    ctx.commit("setAlert", {show: true, text: error}, {root: true});
            })
        },
        axiosDeletePermissionInDepartments(ctx, data) {
            return axios.delete(process.env.VUE_APP_URL+"/set/permission/department/" + data.IDPer, {
                headers: {
                    'Authorization': 'token ' + ctx.getters.getToken,
                    "accept": "application/json",
                    "Content-Type": "application/json",
                }
            }).catch(error=> {
                if(ctx.getters.getToken>20)
                    ctx.commit("setAlert", {show: true, text: error}, {root: true});
            })
        },
        axiosGetPermissionInDepartment(ctx) {
            return axios.get(process.env.VUE_APP_URL+"/set/permission/department/?limit=999999", {
                headers: {
                    'Authorization': 'token ' + ctx.getters.getToken,
                }
            }).then(response=> {
                ctx.commit("updatePermissionsInDepartmentData", response.data.results);
            }).catch(error => {
                if(ctx.getters.getToken>20)
                    ctx.commit("setAlert", {show: true, text: error}, {root: true});
            });
        },
    },
    mutations: {
        updatePermissionsInDepartmentData(state, data) {
            state.permissionInDepartmentData = data;
        },
        updatePermissionsEditDepartment(state, data) {
            data.data.results.sort(function(a, b){
                if(a.original_name < b.original_name) { return -1; }
                if(a.original_name > b.original_name) { return 1; }
                return 0;
            })
            let data1 = JSON.parse(JSON.stringify(data))

            let permissions = [];
            for(let i=0; i<state.KeyBreakdownCopyEdit.length; i++) {
                let title = state.KeyBreakdownCopyEdit[i];
                let titleForButton = state.KeyBreakdownTextNameButtonCopyEdit[i];
                let obj = {
                    title: title,
                    titleForButton: titleForButton,
                    details: [],
                }
                for(let j=0; j<data.data.results.length; j++) {
                    let name = data.data.results[j].name;
                    if(title.indexOf(name) >= 0) {
                        if(name.indexOf(title) !== null) {
                            let details = {
                                name: name,
                                original_name: data.data.results[j].original_name,
                                buttonText: name === "hide_payments_and_incomes_with_such_accounts"? "such Accounts" : "no one",

                                id: data.data.results[j].id,
                                button1Show: data.data.results[j].need_user_choices,
                                button2Show: name === "hide_payments_and_incomes_with_such_accounts",
                                button3Show: name === "show_dop_menu_choosed_columns_in_payment_list",
                                activeCheckboxInMenu: {
                                    departments: [],
                                    employees: [],
                                    account: [],
                                    columns: [],
                                }
                            }
                            // if(permissions.length === 0) {
                            //     details.button1Show = true;
                            // }
                            obj.details.push(details);
                            data1.data.results = data1.data.results.filter(a=> a.name !== name)

                        }
                    }

                }
                if(i === state.KeyBreakdownCopyEdit.length - 1) {
                    data1.data.results.map(a=> {
                        let details = {
                            name: a.name,
                            original_name: a.original_name,
                            buttonText: "no one",

                            id: a.id,
                            button1Show: false,
                            activeCheckboxInMenu: {
                                departments: [],
                                employees: [],
                                account: [],
                                columns: [],
                            }
                        }
                        obj.details.push(details);
                    })
                }
                permissions.push(obj);

            }
            state.permissionsCopyEdit = JSON.parse(JSON.stringify(permissions));
        },

        responseDelete(state, data) {
            state.responseDelete = data;
        },
        setShowEditDepartment(state, data) {
            state.showEditDepartment = data;
        },
        changeActiveCheckboxInMenuEditDepartment(state, data) {

            for(let i=0; i<state.permissionsCopyEdit.length; i++) {
                // console.log(data.title)
                // console.log(state.permissionsCopyEdit[i])
                if(state.permissionsCopyEdit[i].title == data.title) {
                    // console.log("data")


                    for(let j=0; j<state.permissionsCopyEdit[i].details.length; j++) {
                        if(state.permissionsCopyEdit[i].details[j].id === data.id) {
                            if(data.departments.length !== 0) {
                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments = JSON.parse(JSON.stringify(data.departments));
                            } else {
                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments.splice(0, state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments.length)
                            }
                            if(data.employees.length !== 0) {
                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.employees = JSON.parse(JSON.stringify(data.employees));
                            } else {
                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.employees.splice(0, state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.employees.length)
                            }
                            if(Array.isArray(data.account)) {
                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.account = JSON.parse(JSON.stringify(data.account));
                            }
                            if(Array.isArray(data.columns)) {

                                state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.columns = JSON.parse(JSON.stringify(data.columns));
                                // console.log("data")
                                // console.log(state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.columns)
                            }
                            return null;
                        }
                    }
                }
            }
        },
        clearActiveCheckboxInMenuEditDepartment(state) {
            // console.log("CLEAAAER")
            for(let i=0; i<state.permissionsCopyEdit.length; i++) {
                for(let j=0; j<state.permissionsCopyEdit[i].details.length; j++) {
                    // console.log(state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments);
                    state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments.splice(0, state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.departments.length)
                    state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.employees.splice(0, state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.employees.length)
                    state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.account.splice(0, state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.account.length)
                    state.permissionsCopyEdit[i].details[j].buttonText = "no one";
                    if(Array.isArray(state.permissionsCopyEdit[i].details[j].related_account)) {
                        state.permissionsCopyEdit[i].details[j].related_account.splice(0, state.permissionsCopyEdit[i].details[j].related_account.length)
                    }
                    state.permissionsCopyEdit[i].details[j].activeCheckboxInMenu.columns = [];
                }
            }
        },
        setTextButtonEditDepartment(state, data) {
            // console.log("SETSETSET")
            // console.log(data);
            // if(data.text !== undefined && data.text !== null && data.text.length !== 0) {
            //     state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].buttonText = data.text;
            // } else {
            //     state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].buttonText = "no one";
            // }
            if(data.text !== undefined && data.text !== null) {
                // // console.log(92347892374892738947239847238947937498237498);
                state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].buttonText = ""+data.text;
                if(data.textName === "account") {
                    state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].related_account = data.text;
                }
            } else {
                if(data.textName === "account") {
                    state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].buttonText = "such Accounts";
                }else {
                    state.permissionsCopyEdit[data.indexBlock].details[data.indexDetails].buttonText = "no one";
                }
            }
        }
    },
    state: {
        responseDelete: null,
        showEditDepartment: false,
        permissionsCopyEdit: null,
        // KeyBreakdownCopyEdit: ["task", "permission"],
        KeyBreakdownCopyEdit:
        /*Tasks*/[["can_see_task", "show_manual_tasks", "show_tasks_archive", "remove_tags", "assign_tasks_to", "change_status_into_done_without_filling_in_the_clean_fixed", "can_archive_task", "show_tasks_assigned_to", "can_assign_task", "archive_tasks", "can_edit_task", "can_add_file", "can_create_ship_task", "can_create_cargo_task", "can_create_manual_task", "can_delete_tags", "can_off_tags", "can_view_manual_task", "can_view_ship_task", "can_view_cargo_task", "can_view_archive_task", "can_delete_or_rename_file"],
            /*Payments*/["change_the_status_of_the_payment_income", "hide_the_block_report_information_in_payment_income_in_the_status_not_paid", "block_the_payment_income_row_in_the_status_paid_in_the_status_paid_in_the_list_of_payments_incomes","hide_the_block_bank_and_cash_accounts_in_the_status_not_paid", "unarchive_payments_incomes", "show_payment_instructions", "show_archive_of_payments_incomes", "show_payment_calendar", "show_payment_list", "archive_payments_incomes", "edit_payments", "edit_payment_amount", "edit_paid_date", "create_payments_incomes", "add_attachments_into_payments_incomes", "delete_attachments", "show_dop_info_for_acc_in_payments", "show_vessel_and_cp_date_in_payments", "show_dop_menu_choosed_columns_in_payment_list", "can_edit_payment_in_status_paid", "hide_link_operations_in_payments", "block_paid_date_and_bank_receipt_in_payment_detail"],
            /*Cashflow*/["show_cashflow_diagram", "show_cashflow_section", "show_cashflow_list", "hide_payments_and_incomes_with_such_accounts", "block_for_editing_everything_in_the_tab_cash_flow_diagram"],
            /*Accounting*/["create_new_bank_and_cash_accounts", "show_accounting_section", "unarchive_bank_accounts", "show_bank_and_cash_accounts", "edit_fs", "archive_accounts", "unarchive_accounts", "archive_fs", "unarchive_fs", "show_archive_of_trial_balance", "show_trial_balance", "show_financial_statement", "create_new_accounts", "edit_accounts", "create_new_fs", "show_archive_bank_and_cash_accounts", "show_archive_of_bank_accounts", "create_new_bank_accounts", "edit_bank_and_cash_accounts", "edit_bank_accounts", "archive_bank_and_cash_accounts", "unarchive_bank_and_cash_accounts", "archive_bank_accounts"],
            /*Employes*/["show_employes_section", "unarchive_employee", "can_create_user", "can_edit_user", "can_set_permission", "can_edit_permission", "can_create_department", "can_edit_department", "can_archive_user"],
            /*Vessels*/["duplicate_the_payment_income_in_the_cashlow_tab_in_the_vessel", "edit_the_payment_income_in_the_cashlow_tab_in_the_vessel", "show_input_bank_and_cash_accounts_in_freight_additional_freight_detention_invoices_and_voyage_statement_of_account", "show_inputs_bank_and_cash_accounts_account_name_statement_member_in_the_payment_income_creation", "show_archive_ot_time_sheets", "show_archive_of_accounting_invoices", "unarchive_a_noon_report", "archive_a_noon_report", "create_a_new_noon_report", "unarchive_a_soa_sublet", "archive_a_soa_sublet", "create_a_new_soa_sublet", "unarchive_a_statement_with_owners", "archive_a_statement_with_owners", "create_a_new_statement_with_owners", "unarchive_a_detention_invoice", "archive_a_detention_invoice", "create_a_new_detention_invoice", "unarchive_a_voyage_statement_of_account", "archive_a_voyage_statement_of_account", "create_a_new_voyage_statement_of_account", "unarchive_an_additional_freight_invoice", "archive_an_additional_freight_invoice", "create_a_new_additional_freight_invoice", "show_charters_invoices_tab_in_the_voyage_and_sublet_contracts", "unarchive_a_redelivered_vessel", "show_accounting_entries_in_the_vessel", "unarchive_a_sublet_contract", "move_the_redelivered_vessel_to_actual_vessels", "use_the_mode_move_vessels", "show_archive_of_noon_reports", "unarchive_a_freight_invoice", "create_a_new_freight_invoice", "show_soa_sublet_tab_in_the_voyage_and_sublet_contracts", "show_time_sheet_tab_in_the_voyage_and_sublet_contracts", "archive_the_payment_income_in_the_cashlow_tab_in_the_vessel", "show_accounts_in_all_operations", "show_vessels_section", "show_archive_of_actual_vessels", "show_archive_of_redelivered_vessels", "create_a_new_vessel", "move_the_actual_vessel_to_redelivered_vessels", "link_and_unlink_voyage_contracts", "archive_an_actual_vessel", "unarchive_an_actual_vessel", "archive_a_redelivered_vessel", "create_a_voyage_contract", "archive_a_voyage_contract", "unarchive_a_voyage_contract", "create_a_sublet_contract", "archive_a_sublet_contract", "assign_contracts_to", "assign_voyage_contracts_to", "assign_sublet_contracts_to", "add_attachments_into_tasks", "show_owners_tab_in_the_vessel", "show_cash_flow_tab_in_the_vessel", "show_accounting_invoices_tab_in_the_vessel", "show_balances_tab_in_the_vessel", "show_time_sheet_tab_in_the_vessel", "show_reports_in_the_vessel", "archive_a_freight_invoice", "show_tab_balances_in_the_vessel_contract", "show_tab_acc_invoices_in_the_vessel_contract", "create_a_new_payment_or_income"],
            /*Counterparties*/["show_counterparties_database_section", "can_edit_client", "show_counterparties_payments", "can_create_client", "can_archive_client", "can_archive_client_payments", "show_archive_of_counterparties", "show_archive_of_payments_accounts", "add_attachments_into_counterparties"],
            /*Ports*/["show_ports_section", "add_attachments_into_ports", "show_activity_in_ports_detailed_page", "create_ports", "edit_ports", "archive_and_unarchive_ports", "show_archive_of_ports", "write_comments", "delete_attachments_in_ports"],
            /*BDI*/["can_view_index_page", "can_create_index", "can_edit_index", "can_edit_route"],
            /*Notification*/["show_notifications_section"],
            /*Entries*/["show_journal_entries_section_in_accounting", "show_journal_entries_section_in_vessel", "archive_and_unarchive_a_manual_entry", "create_a_manual_entry"],
            /*Calculator*/["archive_and_unarchive_all_users_lists_and_folders", "show_calculator_section"],
            /*CheckList*/["create_or_edit_base_checklist", "show_private_checklists_of_the_users"],
            /*Calendar*/["can_show_payments_in_the_calendar", "can_view_employee_calendar_for", "can_show_tasks_in_the_calendar"],
            /*Vessel Location*/["can_delete_location_ships"],
            []],
        KeyBreakdownTextNameButtonCopyEdit: ["Tasks", "Payments", "Cashflow", "Accounting", "Employes", "Vessels", "Counterparties", "Ports", "BDI", "Notification", "Entries", "Calculator", "Checklist", "Calendar", "Vessel Location", "Others"],
        permissionInDepartmentData: null,
    },
    getters: {
        getPermissionsInDepartmentData(state) {
          return state.permissionInDepartmentData;
        },
        getShowEditDepartment(state) {
            return state.showEditDepartment;
        },
        getPermissionsEditDepartment(state) {
            return state.permissionsCopyEdit;
        },
        getKeyBreakdownCopyEdit(state) {
            return state.KeyBreakdownCopyEdit;
        }
    },
}
